<!--
 * @Description: 
 * @Version: 2.0
 * @Date: 2023-10-20 14:02:57
 * @LastEditTime: 2024-10-28 10:55:16
 * @Author: Auerbach
 * @LastEditors: Auerbach
-->
<script setup lang="ts">
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
const locale = zhCn
// This starter template is using Vue 3 <script setup> SFCs
// Check out https://vuejs.org/api/sfc-script-setup.html#script-setup
</script>

<template>
  <div id="app">
		<el-config-provider :locale="locale">
      <router-view />
		</el-config-provider>
  </div>
</template>

<style>
#app {
	/* font-size: 14px; */
  /* font-family: "Source Han Sans CN", Microsoft YaHei, Helvetica, Arial, sans-serif; */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
}
</style>
